import { render, staticRenderFns } from "./DetalhamentoAnalise.vue?vue&type=template&id=542dc454&lang=pug"
import script from "./DetalhamentoAnalise.vue?vue&type=script&lang=js"
export * from "./DetalhamentoAnalise.vue?vue&type=script&lang=js"
import style0 from "./DetalhamentoAnalise.vue?vue&type=style&index=0&id=542dc454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports